import React, { useEffect } from "react";
import Style from "../../styles/js/StyleUsers";
import Typography from "@material-ui/core/Typography";
import Axios from "axios";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { ColorButton } from "../../components/common/CustomButton.js";
import Button from "@material-ui/core/Button";
import * as Constants from "../../consts/Constants.js";
import * as ScreenText from "../../consts/ScreenText.js";

import TransferList from "../../components/common/TransferList";

function RolesAdmin({
  roles,
  currentRoles,
  mainRole,
  handleClose,
  handlePrimaryRole,
  handleSecondaryRoles,
}) {
  const style = Style();

  const [secondaryRoles, setSecondaryRoles] = React.useState();
  const [role, setRole] = React.useState({});
  const [leftIdList, setLeftIdList] = React.useState([]);
  const [rightIdList, setRightIdList] = React.useState([]);
  const [disabledButton, setDisabledButton] = React.useState(false);
  var finalList = [];

  const setFinalList = (value) => {
    finalList = value;
  };
  const handleRoleChange = (e) => {
    const { value } = e.target;
    setRole(value);
  };

  const getSecondaryRoles = () => {
    let source = Axios.CancelToken.source();
    Axios.get(Constants.FINAL_URL_ROLES + "?mainRole=false&assignable=true", {
      cancelToken: source.token,
    })
      .then((response) => {
        let data = [];
        let ids = [];
        response.data.forEach((roleItem) => {
          data.push(roleItem);
          ids.push(roleItem.id);
        });
        setSecondaryRoles(data);
        setRightIdList(currentRoles);
        setLeftIdList(
          ids.filter((value) => currentRoles.indexOf(value) === -1)
        );
      })
      .catch(function () {});
    return () => source.cancel();
  };

  const createEvent = (val) => {
    return {
      target: {
        value: val,
      },
    };
  };

  const localSave = () => {
    setDisabledButton(true);
    handleClose();
    if (role !== mainRole) handlePrimaryRole(createEvent(role));
    handleSecondaryRoles(finalList);
  };

  useEffect(() => {
    setRole(mainRole);
    getSecondaryRoles();
  }, []);

  return (
    <div className={style.rolesAdmin}>
      <div className={style.titleRolesAdmin}>
        <Typography variant="h5" gutterBottom style={{ marginLeft: "10px" }}>
          {ScreenText.USERS_ROLES_ADMIN_TITLE}
        </Typography>
      </div>
      <div className={style.containerRolesAdmin}>
        <div className={style.mainColumnRoleAdmin}>
          <div>
            <Typography gutterBottom style={{ marginLeft: "10px" }}>
              {ScreenText.USERS_ROLES_ADMIN_MAIN_ROLE}
            </Typography>
            {roles !== undefined && (
              <Select
                className={style.selectRoles}
                name="role"
                labelId="role"
                id="role"
                value={role}
                onChange={handleRoleChange}
              >
                {roles !== undefined &&
                  roles.map((role) => (
                    <MenuItem key={role.id} value={role.id}>
                      {role.description}
                    </MenuItem>
                  ))}
              </Select>
            )}
          </div>
          <div>
            <ColorButton
              className={style.actionButton}
              onClick={localSave}
              variant="contained"
              disabled={disabledButton}
            >
              {ScreenText.USERS_ROLES_ADMIN_SAVE_BUTTON}
            </ColorButton>
            <Button
              className={style.actionButton}
              onClick={handleClose}
              variant="contained"
            >
              {ScreenText.USERS_ROLES_ADMIN_CANCEL_BUTTON}
            </Button>
          </div>
        </div>
        <div className={style.transferListColumn}>
          <TransferList
            items={secondaryRoles}
            leftItems={leftIdList}
            rightItems={rightIdList}
            setFinalList={setFinalList}
            leftTitle={ScreenText.USERS_ROLES_ADMIN_LEFT_LIST}
            rightTitle={ScreenText.USERS_ROLES_ADMIN_RIGHT_LIST}
          />
        </div>
      </div>
    </div>
  );
}

export default React.memo(RolesAdmin);
